import styled, { css } from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { ButtonLabel } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import { AI_GRADIENT_GREEN, AI_GRADIENT_GREEN_ACTIVE } from "../../../../components/styles";

export const LINE_HEIGHT = "11px";

export const smButtonStyle = css`
    height: fit-content !important;
    padding: 6px 12px;

    ${ButtonLabel} {
        font-size: ${LINE_HEIGHT};
    }
`;

export const StyledSuggestionItem = styled.li`
    ${setFontVariant("chip1", colorsPalettes.carbon[400])};

    padding: 4px 12px;

    border-radius: 8px;
    background: ${AI_GRADIENT_GREEN};

    transition:
        background 180ms ease-out,
        box-shadow 180ms ease-out;

    cursor: pointer;
    user-select: none;

    &:hover {
        background: ${AI_GRADIENT_GREEN_ACTIVE};

        box-shadow:
            inset 0 1px 1px rgba(255, 255, 255, 0.55),
            0 1px 2px rgba(31, 38, 135, 0.1),
            0 6px 20px -8px rgba(31, 38, 135, 0.06);

        backdrop-filter: blur(8px);
        -webkit-backdrop-filter: blur(8px);
    }
`;

export const StyledSuggestionList = styled.ul`
    display: flex;
    gap: 8px;
    flex-direction: column;
    margin: 0;
`;

export const StyledActionsWrapper = styled(Flex)`
    gap: 8px;
    justify-content: space-between;
    width: 100%;
`;
